import { render, staticRenderFns } from "./SettingsBusiness.vue?vue&type=template&id=01e7c6a3&scoped=true&"
import script from "./SettingsBusiness.vue?vue&type=script&lang=js&"
export * from "./SettingsBusiness.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBusiness.vue?vue&type=style&index=0&id=01e7c6a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e7c6a3",
  null
  
)

export default component.exports